module.exports = __webpack_public_path__ + "img/xlsx.d55a9c38.png";